const UPDATE_OPTION = 1;
const PUSH_OPTION = 2;
const PUSH_OPTION_WITH_CONFIRMATION = 3;

/** Same popup choice as the Pricer Push to Team Run button. */
export function teamRunPopupFromPushCheck(responseData, option) {
  if (!responseData || !option?.summaryId) return null;
  const quantity = {
    ask_quantity: responseData.ask_quantity,
    bid_quantity: responseData.bid_quantity,
  };
  const productId = option.productId ?? responseData.product_id ?? null;
  const popupType = responseData.popup_type;

  if (popupType === UPDATE_OPTION) {
    return {
      kind: "update",
      data: responseData.rows,
      colors: responseData,
      tradingCompanies: responseData.trading_companies,
      quantity,
      summaryId: option.summaryId,
      productId,
      agreedDeltas: responseData.agreed_deltas ?? [],
    };
  }

  if (
    popupType === PUSH_OPTION ||
    popupType === PUSH_OPTION_WITH_CONFIRMATION
  ) {
    return {
      kind: "push",
      data: responseData,
      tradingCompanies: responseData.trading_companies,
      quantity,
      summaryId: option.summaryId,
      productId,
    };
  }

  return null;
}
